import { Layout, Modal, Select, message } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  getAllSponsor,
  getSponsorsForVaccine,
  updateSponsorForVaccine,
} from '../../services/api/cashless-vaccination';
import '../../App.css';

const AddSponsors = ({
  sponsor,
  vaccineId,
  vaccineName,
  onCancel,
  refreshTableData,
}) => {
  console.log(
    {
      sponsor,
      vaccineId,
      onCancel,
      vaccineName,
      refreshTableData,
    },
    '[AddSponsors][props]'
  );

  const [allSponsor, setAllSponsorName] = useState([]);
  const [selectedSponsors, setSelectedSponsors] = useState([]);

  useEffect(() => {
    // Fetch sponsors for the given vaccine
    getSponsorsForVaccine(vaccineId)
      .then((response) => {
        console.log({ response }, '[response][getSponsorsForVaccine]');
        if (response.body.message === 'success') {
          setSelectedSponsors(response.body.data.map((e) => e.sponsorId));
        }
      })
      .catch((err) => {
        console.log({ err }, '[getSponsorsForVaccine][AddSponsors]');
        message.error(err);
      });

    // Fetch all sponsors
    getAllSponsor()
      .then((response) => {
        console.log({ a: response.body.data }, '[response][a]');
        // debugger;
        if (response.body.message === 'success') {
          setAllSponsorName(response.body.data);
        }
      })
      .catch((err) => {
        console.log({ err }, '[getAllSponsor][AddSponsors]');
        message.error(err);
      });
  }, []);

  const handleSelectChange = (selectedItems) => {
    console.log(selectedItems, '[selectedItems]');
    setSelectedSponsors(selectedItems);
  };

  const submitSponsorsVaccination = () => {
    console.log({ vaccineId, selectedSponsors }, '[vaccineId]');
    updateSponsorForVaccine(selectedSponsors, vaccineId)
      .then((response) => {
        console.log({ response }, '[response][updateSponsorForVaccine]');
        if (response.body.message === 'success') {
          onCancel();
          refreshTableData();
          message.success('Updated');
        }
      })
      .catch((error) => {
        console.error({ error }, '[updateSponsorForVaccine][error]');
        message.error(error);
      });
  };

  console.log(selectedSponsors, allSponsor, '[mergedData]');
  return (
    <Modal
      title={`Add Sponsor for vaccine Id ${vaccineId} - ${
        vaccineName.length > 20
          ? vaccineName.substring(0, 20) + '......'
          : vaccineName
      }`}
      visible={sponsor}
      onCancel={onCancel}
      className="custom-modal"
      onOk={submitSponsorsVaccination}
      okText="Save"
      okButtonProps={{ style: { backgroundColor: '#008f7b', color: 'white' } }}
      cancelButtonProps={{
        style: { backgroundColor: '#008f7b', color: 'white' },
      }}
    >
      <div>
        <Select
          mode="multiple"
          style={{
            width: '100%',
          }}
          multipleItemBg="008f7b"
          onChange={handleSelectChange}
          placeholder="Please select"
          value={selectedSponsors}
          filterOption={(inputValue, option) =>
            option.props.children
              .toLowerCase()
              .indexOf(inputValue.toLowerCase()) !== -1
          }
          className="custom-select"
        >
          {allSponsor.map((sponsor) => {
            return (
              <Select.Option key={sponsor.sponsorId} value={sponsor.sponsorId}>
                {sponsor.sponsorName}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </Modal>
  );
};

export default AddSponsors;
